import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import StyledButton from "../StyledButton";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CreateIcon from "@mui/icons-material/Create";
import InputBase from "@mui/material/InputBase";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    borderRadius: "15px",
    padding: theme.spacing(1),
  },

  "& .MuiTypography-root": {
    fontWeight: 700,
  },
}));

const TextField = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    border: "1px solid",
    borderColor: "#E0E3E7",
    fontSize: 16,
    padding: "10px 12px",
  },
}));

const UpdateAmountDialog = ({ reload, prevAmount, orderId }) => {
  const [open, setOpen] = React.useState(false);
  const [amount, setAmount] = React.useState(0);
  const [showError, setShowError] = React.useState(false);

  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setShowError(false);
    setOpen(false);
  };

  React.useEffect(() => setAmount(prevAmount), [prevAmount]);

  const handleSubmit = async () => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) navigate("/sign-in");
    if (amount === "") {
      setShowError(true);
    } else {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/v1/api/admin/update-transaction-amount/${orderId}`,
        { amount: parseInt(amount) },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setOpen(false);
      reload();
    }
  };

  return (
    <div>
      <CreateIcon
        onClick={handleClickOpen}
        sx={{ fontSize: "14px", margin: "0 0 15px 7px", cursor: "pointer" }}
      />
      <BootstrapDialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={"xs"}
      >
        <DialogTitle>Edit Total Amount</DialogTitle>
        <DialogContent>
          <FormControl variant="standard" fullWidth>
            <InputLabel
              shrink
              htmlFor="name"
              sx={{ fontWeight: 700, fontSize: "20px", color: "#000" }}
            >
              Title
            </InputLabel>
            <TextField
              autoFocus
              value={amount}
              required
              error={showError ? true : false}
              margin="dense"
              id="name"
              label="Edit Amount"
              type="number"
              fullWidth
              size="small"
              variant="outlined"
              helperText={showError && "Category Name is required"}
              onChange={(e) => setAmount(e.target.value)}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <StyledButton
            variant="outlined"
            text={"Cancel"}
            onClick={handleClose}
          >
            Cancel
          </StyledButton>
          <StyledButton text={"Submit"} onClick={handleSubmit}>
            Subscribe
          </StyledButton>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default UpdateAmountDialog;
